import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IPageDTO } from '../dto/page/page.dto';
import { IVideoMediaDTO } from '../dto/media/video-media.dto';

@Injectable({
  providedIn: 'root',
})
export class ClipService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  public fetchClips(next?: string): Observable<IPageDTO<IVideoMediaDTO>> {
    let httpParams: HttpParams = new HttpParams();
    if (next) {
      httpParams = httpParams.append('nextPageId', next);
    }
    return this.httpClient.get<IPageDTO<IVideoMediaDTO>>(
      '/api/v1/private/clips',
      {
        withCredentials: true,
        params: httpParams,
      }
    );
  }
}
